import { render, staticRenderFns } from "./Impressions.vue?vue&type=template&id=5249ce39&scoped=true"
import script from "./Impressions.vue?vue&type=script&lang=js"
export * from "./Impressions.vue?vue&type=script&lang=js"
import style0 from "./Impressions.vue?vue&type=style&index=0&id=5249ce39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5249ce39",
  null
  
)

export default component.exports